import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Sparkles, ArrowRight, CheckCircle } from "lucide-react";

interface CTASectionProps {
  companyName: string;
  onCtaClick: () => void;
  isLoading?: boolean;
}

const benefits = [
  "Automatische Content-Erstellung",
  "Professionelle Texte & Visuals",
  "Optimales Timing für maximale Reichweite",
  "Vollständige Strategie-Planung",
];

export function CTASection({ companyName, onCtaClick, isLoading }: CTASectionProps) {
  return (
    <section className="py-12" data-testid="section-cta">
      <Card className="bg-gradient-to-br from-primary/10 via-primary/5 to-background border-primary/20">
        <CardContent className="py-10 px-6 lg:px-12 text-center">
          <div className="max-w-2xl mx-auto space-y-6">
            <div className="flex items-center justify-center gap-2 text-primary">
              <Sparkles className="w-6 h-6" />
              <span className="text-sm font-semibold uppercase tracking-wide">
                Klingt gut?
              </span>
            </div>

            <h2 className="text-2xl lg:text-4xl font-bold font-playfair">
              A-Team für {companyName} aktivieren
            </h2>

            <p className="text-muted-foreground text-lg">
              Lass unser A-Team jeden Monat professionellen Content für dich erstellen.
              Ohne Aufwand, ohne Stress.
            </p>

            {/* Benefits list */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left max-w-md mx-auto">
              {benefits.map((benefit, index) => (
                <div 
                  key={benefit} 
                  className="flex items-center gap-2"
                  data-testid={`text-benefit-${index}`}
                >
                  <CheckCircle className="w-4 h-4 text-primary flex-shrink-0" />
                  <span className="text-sm">{benefit}</span>
                </div>
              ))}
            </div>

            {/* Price */}
            <div className="py-4">
              <span className="text-3xl lg:text-4xl font-bold">Ab €249</span>
              <span className="text-muted-foreground">/Monat</span>
            </div>

            {/* CTA Button */}
            <Button
              size="lg"
              className="w-full sm:w-auto px-8 py-6 text-lg"
              onClick={onCtaClick}
              disabled={isLoading}
              data-testid="button-cta-activate"
            >
              {isLoading ? (
                "Wird geladen..."
              ) : (
                <>
                  Jetzt starten
                  <ArrowRight className="w-5 h-5 ml-2" />
                </>
              )}
            </Button>

            <p className="text-xs text-muted-foreground">
              Unverbindliche Anfrage • Keine Zahlungsdaten erforderlich
            </p>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
